import React from 'react'
import type { IColumn } from 'shared/ui/TableNew'
import { EmptyCell, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { AiAgentUserCell } from 'entities/AICalling/ui/columns/AiAgentUserCell'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'
import { getCellForName } from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import { CellDuration } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellDuration/CellDuration'
import { CellAudioUi } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellAudio/CellAudio'
import { CellInbox } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellInbox/CellInbox'

import { type CallingContactListItem } from './store/CallingContactListItem'

export const getColumns = (
  onOpenContactsDetails: IOpenContactsDetails
): IColumn<CallingContactListItem>[] => [
  {
    field: 'contact',
    name: 'Contact',
    width: '200px',
    isDisabledChangeVisible: true,
    renderRowCell: (row, _, config) =>
      getCellForName({
        row: row.contact,
        onOpenContactsDetails,
        config,
        inboxId: row.inbox?.id,
        conversationCallInfo: {
          inboxId: row.inbox?.id,
          conversationId: row.origin?.conversation?.id,
        },
      }),
  },
  {
    field: 'number',
    name: 'Phone',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => row.number && getLabelAsNumberInternationalFormat(row.number),
  },
  {
    field: 'duration',
    name: 'Duration',
    renderRowCell: (row) => {
      return <CellDuration duration={row.callDuration} />
    },
  },
  {
    field: 'audio',
    name: 'Audio',
    minWidth: 90,
    isOverflowInitial: true,
    renderRowCell: (row, column, config) => {
      if (row.audioUrl) {
        return <CellAudioUi url={row.audioUrl} tableConfig={config} />
      }

      return <EmptyCell />
    },
  },
  {
    field: 'created_at',
    name: 'Date',
    renderRowCell: (row) => {
      return row.created_at ? (
        <Typography
          ariaLabel={'time'}
          color={'var(--content-primary-disabled)'}
          variant={'body-sm-regular'}
        >
          {uiStore.dayjs(row.created_at).format(DayjsFormats.slashWithAtDash)}
        </Typography>
      ) : (
        <EmptyCell />
      )
    },
  },
  {
    field: 'user',
    name: 'User',
    renderRowCell: () => <AiAgentUserCell />,
  },
  {
    field: 'inbox',
    name: 'Inbox',
    renderRowCell: (row) => {
      if (!row.inbox) {
        return <EmptyCell />
      }
      return <CellInbox name={row.inboxName} number={row.inboxNumber} />
    },
  },
]
